module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('title', [_vm._v("The Whole Church Sings")]), _vm._v(" "), _c('link', {
    attrs: {
      "href": "../styles/stylesheet.css",
      "rel": "stylesheet",
      "type": "text/css"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "OT"
  }, [_c('a', {
    attrs: {
      "id": "page_iv"
    }
  }, [_vm._v("Contents")])]), _c('a', {
    attrs: {
      "id": "page_iv"
    }
  }), _c('p', {
    staticClass: "TOC_fbm1",
    attrs: {
      "id": "pre001"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_iv"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/preface#pre001"
    }
  }, [_vm._v("Preface")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC_fbm",
    attrs: {
      "id": "abb001"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/abbreviations#abb001"
    }
  }, [_c('i', [_vm._v("Abbreviations")])])]), _vm._v(" "), _c('p', {
    staticClass: "TOC_ch",
    attrs: {
      "id": "ch001"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter001#ch001"
    }
  }, [_vm._v("1. The Reformation Celebrated in Song")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC_ch",
    attrs: {
      "id": "ch002"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter002#ch002"
    }
  }, [_vm._v("2. Pre-Reformation Vernacular Song")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC_ch",
    attrs: {
      "id": "ch003"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter003#ch003",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3. Wittenberg Reforms, 1517–23")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC_ch",
    attrs: {
      "id": "ch004"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter004#ch004",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4. The Initial Repertory of Hymns, 1523–24")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC_ch",
    attrs: {
      "id": "ch005"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter005#ch005",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5. The Publication of the Wittenberg Hymns, 1523–24")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC_ch",
    attrs: {
      "id": "ch006"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter006#ch006",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6. A Congregational Hymnal in Wittenberg, 1524–26")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC_ch",
    attrs: {
      "id": "ch007"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter007#ch007",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7. Liturgical Developments in Wittenberg, 1523–26")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC_ch",
    attrs: {
      "id": "ch008"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter008#ch008",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8. From Enchyridion to Geistliche lieder, 1524–29")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC_app",
    attrs: {
      "id": "app001"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/appendix001#app001",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Appendix 1")])])]), _vm._v(" "), _c('p', {
    staticClass: "TOC_app_title"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/appendix001#app001",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Enchyridion geistlicher gesenge und psalmen fur die leyen")]), _vm._v(", Wittenberg, 1524–26")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC_app",
    attrs: {
      "id": "app002"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/appendix002#app002",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Appendix 2")])])]), _vm._v(" "), _c('p', {
    staticClass: "TOC_app_title"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/appendix002#app002",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Geistliche Lieder")]), _vm._v(", Wittenberg: Klug, 1529/33")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC_app",
    attrs: {
      "id": "app003"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/appendix003#app003",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Appendix 3")])])]), _vm._v(" "), _c('p', {
    staticClass: "TOC_app_title"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/appendix003#app003",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Luther’s Hymns and Liturgical Chants in Critical Editions and Hymnals")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC_app",
    attrs: {
      "id": "app004"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/appendix004#app004",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Appendix 4")])])]), _vm._v(" "), _c('p', {
    staticClass: "TOC_app_title"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/appendix004#app004",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Hymns by Authors Other than Luther")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC_app",
    attrs: {
      "id": "app005"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/appendix005#app005",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Appendix 5")])])]), _vm._v(" "), _c('p', {
    staticClass: "TOC_app_title"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/appendix005#app005",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Hymn Collections, 1524–36")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC_fbm",
    attrs: {
      "id": "bib001"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_vi"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/bibliography#bib001",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Bibliography")])])]), _vm._v(" "), _c('p', {
    staticClass: "TOC_fbm",
    attrs: {
      "id": "ind001"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/index001#ind001",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Index of First Lines")])])]), _vm._v(" "), _c('p', {
    staticClass: "TOC_fbm",
    attrs: {
      "id": "ind002"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/index002#ind002",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Index of Names and Subjects")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ef6128c6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/contents.vue
// module id = 66
// module chunks = 0